<div class="page-container">
  <div class="page-header">
    <div class="page-header-left">
      <h2 class="page-title">Automated Alert Rules</h2>
      <p class="page-subtitle">Configure alerts that automatically send correspondence when triggered.</p>
    </div>
    @if (!loading) {
      <div class="summary-badge">
        <mat-icon>notifications_active</mat-icon>
        {{ enabledCount }} of {{ alerts.length }} rules enabled
      </div>
    }
  </div>

  @if (loading) {
    <div class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Loading alert rules...</span>
    </div>
  } @else if (alerts.length === 0) {
    <div class="empty-state">
      <mat-icon>notifications_none</mat-icon>
      <p>No alert rules configured.</p>
    </div>
  } @else {
    <div class="alerts-list">
      @for (alert of alerts; track alert.id; let last = $last) {
        <div class="alert-card" [class.alert-disabled]="!alert.enabled">
          <div class="alert-card-left">
            <div class="alert-icon-wrap" [class.icon-enabled]="alert.enabled" [class.icon-disabled]="!alert.enabled">
              <mat-icon>{{ alert.enabled ? 'notifications_active' : 'notifications_off' }}</mat-icon>
            </div>
          </div>

          <div class="alert-card-body">
            <div class="alert-name">{{ alert.name }}</div>
            <div class="alert-trigger">
              <mat-icon class="trigger-icon">bolt</mat-icon>
              Trigger: {{ alert.triggerEvent }}
            </div>
            <div class="alert-template">
              <mat-icon class="trigger-icon">description</mat-icon>
              Template: {{ alert.templateName }}
            </div>
            @if (alert.lastTriggered) {
              <div class="alert-last-triggered">
                <mat-icon class="trigger-icon">history</mat-icon>
                Last triggered: {{ alert.lastTriggered | date:'MM/dd/yyyy h:mm a' }}
              </div>
            } @else {
              <div class="alert-last-triggered never">
                <mat-icon class="trigger-icon">history</mat-icon>
                Never triggered
              </div>
            }
          </div>

          <div class="alert-card-right">
            <mat-slide-toggle
              [checked]="alert.enabled"
              (change)="onToggleAlert(alert, $event.checked)"
              [color]="'primary'"
              [attr.aria-label]="'Toggle ' + alert.name">
              {{ alert.enabled ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
          </div>
        </div>
        @if (!last) {
          <mat-divider></mat-divider>
        }
      }
    </div>
  }
</div>
